<template>
    <ProductListDialog
            :dialogTitle="dialogTitle"
            :centerDialogVisible="visible"
            @updateVisible="updateVisible"
            @resetPopupData="resetPopupData"
            @submitPopupData="submitPopupData"
            :popupWidth="'1000px'"
    >
<!--        <el-form :inline="true" :model="query" ref="query">-->
<!--            <el-form-item  label="商品编号" prop="skuCode" >-->
<!--                <el-input v-model="query.skuCode" placeholder="商品编号"></el-input>-->
<!--            </el-form-item>-->
<!--            <el-form-item  label="商品名称" prop="skuName" >-->
<!--                <el-input v-model="query.skuName" placeholder="商品名称"></el-input>-->
<!--            </el-form-item>-->
<!--            <el-form-item  label="类目名称" prop="categoryName" >-->
<!--                <el-input v-model="query.categoryName" placeholder="类目名称"></el-input>-->
<!--            </el-form-item>-->
<!--            <el-form-item  label="品牌" prop="brandName" >-->
<!--                <el-input v-model="query.brandName" placeholder="品牌"></el-input>-->
<!--            </el-form-item>-->
<!--            <el-button icon="el-icon-search" @click="handleSearch">查询</el-button>-->
<!--            <el-button icon="el-icon-delete" @click="handleClear">重置</el-button>-->
<!--        </el-form>-->
        <div style="margin-bottom: 10px">
            <e-search
                    :data="query"
                    :field-list="fieldList"
                    :list-type-info="listTypeInfo"
                    :width="listTypeInfo.width"
                    @handleFilter="handleSearch"
                    @handleReset="handleClear"
                    @handleFocus="focusClassify"
            ></e-search>
        </div>
        <TableList
                :table-data="tableData"
                :table-label="tableLabel"
                :loading="loading"
                :selection-show="multipleSelection"
                :row-key="rowKey"
                @handleSelectionChange="handleSelectionChange"
                :handleIsSelection="handleIsSelection"
        >
            <template v-slot:skuName="slot">
                <div class="table-product-name">
                    {{slot.scope.row.skuName}}
                </div>
            </template>
        </TableList>

        <div style="display: flex;justify-content:space-between;margin-top: 20px;">
            <el-checkbox v-model="checkAll">选择全部商品</el-checkbox>
            <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :page-sizes="[10, 20, 30, 40, 50, 60, 80, 100, 200]"
                    layout="total, sizes, prev, pager, next, jumper"
                    :current-page="productTagPage.currentPage"
                    :page-size="productTagPage.pageSize"
                    :total="productTagPage.pageTotal"
                    prev-text="上一页"
                    next-text="下一页"
            >
            </el-pagination>
        </div>
        <!-- 所属分类 -->
        <classifyTree
                :classifyVisible="classifyVisible"
                :categoryTreeData="categoryTreeData"
                :defaultCheckedKeys="defaultCheckedKeys"
                @submitPopupData="classifySubmitPopupData"
                @resetPopupData="classifyResetPopupData"
        ></classifyTree>
    </ProductListDialog>
</template>

<script>
    import ProductListDialog from '../../../../../components/common/epecDialog'
    import TableList from '../../common/e-table-list'
    import agreementApi from '../../../api/agreement/index'
    import ESearch from '../../common/e-search'
    import ClassifyTree from './classifyTree'
    export default {
        name: "productAddDialog",
        components: {
            ProductListDialog,
            TableList,
            ESearch,
            ClassifyTree
        },
        props: {
            visible:{
                type:Boolean,
                required: true
            },
            agreementDetail:{
                type:Object,
                required: true,
            },
            materialCode:{
                type:String,
                required: true
            }
        },
        data() {
            return {
                loading:false,
                tableData:[],
                tableLabel: [
                    // { label: '图片', param: 'defaultImage', align: 'center' ,slot:'pic', width:'100'},
                    { label: '单品编号', param: 'skuCode', align: 'center',},
                    { label: '商品名称', param: 'skuName', align: 'center',slot:'skuName' },
                    { label: '类目名称', param: 'categoryName', align: 'center'},
                    { label: '计量单位', param: 'unitValue', align: 'center', width:'80'},
                    { label: '品牌', param: 'brandName', align: 'center'},
                    { label: '平台价(元)', param: 'skuPrice', align: 'center',width:'100'},
                ] ,
                productTagPage: {
                    currentPage: 1,
                    pageSize: 10,
                    pageTotal: 0,
                },
                query:{
                    skuCode:'',
                    skuName:'',
                    categoryName:'',
                    brandName:'',
                    categoryIdList:null
                },
                dialogTitle:'商品清单',
                multipleSelection:true,
                rowKey:'skuId',
                selectedProduct:[],
                categoryIds:[],//添加商品搜索时的查询条件
                fieldList: [
                    { label: '商品编码', type: 'input', value: 'skuCode', placeholder: '支持模糊搜索' },
                    { label: '商品名称', type: 'input', value: 'skuName', placeholder: '支持模糊搜索' },
                    { label: '类目名称', type: 'dialog', value: 'categoryName', placeholder: '支持多选' },
                    { label: '品牌名称', type: 'input', value: 'brandName', placeholder: '支持模糊搜索' },
                ],
                listTypeInfo: {
                    width: {
                        labelWidth: 120,
                        itemWidth: 200
                    },
                },
                // 所属分类
                classifyVisible: false,
                classifyData: null,
                defaultCheckedKeys: [],
                categoryTreeData:[],
                checkAll:false
            }
        },
        computed: {},
        created() {
            this.getProductPriceList()
            // this.getProductPriceList()
        },
        methods: {
            handleSearch(val){
                this.query = {...val}
                this.productTagPage.currentPage = 1
                this.productTagPage.pageSize = 10
                this.getProductPriceList()
            },
            handleClear(){
                this.query.skuName = ''
                this.query.skuCode = ''
                this.query.categoryName = ''
                this.query.brandName = ''
                this.query.categoryIdList = null
                this.getProductPriceList()
            },
            handleSizeChange(val){
                this.productTagPage.pageSize = val
                this.productTagPage.currentPage = 1
                this.getProductPriceList()
            },
            handleCurrentChange(val){
                this.productTagPage.currentPage = val
                this.getProductPriceList()
            },
            updateVisible(){
                this.$emit('close')
                this.selectedProduct = []
            },
            resetPopupData(){
                this.$emit('close')
                this.selectedProduct = []
            },
            submitPopupData(){
                if(this.checkAll){
                    let params = {
                    agreementId:this.agreementDetail.agreementId,
                    brandName:this.query.brandName,
                    skuCode:this.query.skuCode,
                    skuName:this.query.skuName,
                    categoryIdList:this.query.categoryIdList
                }
                
                    agreementApi.addAllProductsList(params)
                    .then((res) => {
                        if(res.code == '200'){
                            this.$message({
                                    type:'success',
                                    message:'新增协议价商品成功'
                                })
                                this.$emit('close')
                                this.$emit('refreshProduct')
                                this.selectedProduct = []
                        }
                    })

                    
                }else{
                    let params = this.formatAddProductParams()
                if(this.selectedProduct.length > 0){
                    agreementApi.addProductSharedAgreement(params)
                        .then((res) => {
                            if(res.code == '200'){
                                this.$message({
                                    type:'success',
                                    message:'新增协议价商品成功'
                                })
                                this.$emit('close')
                                this.$emit('refreshProduct')
                                this.selectedProduct = []
                            }
                        })
                }else {
                    this.$message({
                        type:'info',
                        message:'请选择协议价商品'
                    })
                }
                }
                

            },
            handleSelectionChange(val){
                this.selectedProduct = val
            },
            formatParams(){
                let res = {}
                res.pageNum = this.productTagPage.currentPage
                res.pageSize = this.productTagPage.pageSize
                res.supplierCompanyId = this.agreementDetail.supplierCompanyId
                res.categoryIds = this.categoryIds
                res.exportStatus = 101
                res.enable = 1
                res.skuCode = this.query.skuCode
                res.skuName = this.query.skuName
                return res
            },
            formatConfirmStatus(val){
                let res = ''
                switch (val) {
                    case 0: res='未提交';break;
                    case 1: res='待确认';break;
                    case 2: res='已确认';break;
                    case 3: res='拒绝'; break;
                }
                return res;
            },
            formatRate(row){
                return row.agreementPrice ? ((((row.price - row.agreementPrice) / row.price) * 100).toFixed(2)) + '%' : 0;
            },
            formatAddProductParams(){
                let res = {}
                res.agreementId = this.agreementDetail.agreementId
                res.skuIdList  = []


                this.selectedProduct.forEach((item) => {
                    res.skuIdList.push(item.skuId)
                })

                return res
            },
            async getProductPriceList(){
                let params = {
                    pageNum: this.productTagPage.currentPage,
                    pageSize: this.productTagPage.pageSize,
                    agreementId:this.agreementDetail.agreementId,
                    skuName: this.query.skuName,
                    skuCode: this.query.skuCode,
                    categoryIdList: this.query.categoryIdList,
                    brandName: this.query.brandName
                }

                let res = await agreementApi.querySharedAgreementProduct(params)
                if(res.data){
                    this.tableData = res.data.records
                    this.productTagPage.pageTotal = res.data.total
                }
            },
            // 选择所属分类
            focusClassify() {
                this.getAllCategoryTree()
                if (this.query.categoryIdList?.length) {
                    this.defaultCheckedKeys = this.query.categoryIdList
                }
                this.classifyVisible = true
            },
            async getAllCategoryTree() {
                let params = {
                    agreementId:this.agreementDetail.agreementId
                }
                let res = await agreementApi.getSharedResourceAllCategoryTree(params)
                if (res.code == '200') {
                    this.categoryTreeData = res.data.children
                }
            },
            // 关闭所属分类弹框
            classifyResetPopupData() {
                this.classifyVisible = false
            },

            // 所属分类确定
            classifySubmitPopupData(val) {
                // this.defaultCheckedKeys = val.map(item=>item.categoryId)
                let filterNode = []
                val.map((item) => {
                    if (item.leafFlag) {
                        filterNode.push(item)
                    }
                })
                console.log(filterNode, '过滤后的categoryId')
                this.query.categoryIdList = filterNode.map((item) => item.categoryId)
                let arr = val.map((item) => item.categoryName)
                this.query.categoryName = arr.join('、')
                this.classifyVisible = false
            },
            handleIsSelection(){
                return !this.checkAll
            }
        }

    }
</script>

<style lang="scss" scoped>
    .el-dialog{
        display: flex;
        flex-direction: column;
        margin:0 !important;
        position:absolute;
        top:50%;
        left:50%;
        transform:translate(-50%,-50%);
        /*height:600px;*/
        max-height:calc(100% - 30px);
        max-width:calc(100% - 30px);
    }
    .el-dialog .el-dialog__body{
        flex:1;
        overflow: auto;
    }
</style>
